import React from "react";
import { motion } from "framer-motion";
import { LUXE_MATRIX, LUXE_WORDS } from "@/lib/perspective";

export const LuxePerspective = () => (
  <div data-testid="luxe-perspective" className="rounded-3xl p-8 sm:p-12" style={{ background: "#071711", color: "#F5F3ED" }}>
    <div className="flex flex-wrap gap-x-8 gap-y-3">
      {LUXE_WORDS.map((w, i) => (
        <motion.span
          key={w}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: i % 2 ? 0.45 : 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: i * 0.08 }}
          className="font-serif text-3xl font-light tracking-tight sm:text-5xl"
          style={{ color: i % 3 === 0 ? "var(--accent-gold)" : "#F5F3ED" }}
        >
          {w}
        </motion.span>
      ))}
    </div>

    <div className="mt-14 space-y-6">
      <div className="overline">The Luxe Matrix</div>
      {LUXE_MATRIX.map((pair, i) => (
        <motion.div
          key={pair.a}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: i * 0.12 }}
          className="grid grid-cols-[1fr_auto_1fr] items-center gap-4 border-b border-[#2A4F42] pb-5"
        >
          <span className="text-right font-serif text-xl sm:text-2xl" style={{ color: "var(--accent-gold)" }}>{pair.a}</span>
          <div className="relative h-px w-16 sm:w-28" style={{ background: "#2A4F42" }}>
            <motion.div
              className="absolute top-1/2 h-2 w-2 -translate-y-1/2 rounded-full"
              style={{ background: "var(--accent-gold)" }}
              initial={{ left: "10%" }}
              whileInView={{ left: `${30 + (i * 12) % 45}%` }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
            />
          </div>
          <span className="font-serif text-xl sm:text-2xl" style={{ color: "#B4C4BA" }}>{pair.b}</span>
        </motion.div>
      ))}
    </div>

    <p className="mt-12 max-w-2xl font-serif text-2xl font-light leading-snug sm:text-3xl">
      Luxury isn't simply a higher price. It is a different standard of evaluation.
    </p>
  </div>
);

export default LuxePerspective;
